module.exports = __webpack_public_path__ + "static/media/adjust-white.346725f8.svg";